export default "__VITE_ASSET__Cgrh5pSU__"